import { z } from 'zod';
import http, { HttpError } from '../http';
import {
  ImpersonateUserResponse,
  ImpersonateUserResponseSchema,
  ImpersonationUserDto,
  ImpersonationUserDtoSchema,
  ImpersonationError,
  ImpersonationErrorCode,
  ImpersonationErrorResponse,
  ImpersonationErrorResponseSchema,
} from '@cargovibe/shared-types';

export const impersonateUser = async (externalAuthId: string): Promise<ImpersonateUserResponse> => {
  try {
    return await http.post<ImpersonateUserResponse>(
      '/impersonateUser',
      ImpersonateUserResponseSchema,
      { externalAuthId }
    );
  } catch (error: unknown) {
    if (error instanceof HttpError) {
      const parsed: z.SafeParseReturnType<unknown, ImpersonationErrorResponse> =
        ImpersonationErrorResponseSchema.safeParse(error.data);
      const body: ImpersonationErrorResponse | undefined = parsed.success ? parsed.data : undefined;
      throw new ImpersonationError(
        body?.error ?? 'Failed to impersonate user',
        body?.errorCode ?? ImpersonationErrorCode.Unknown
      );
    }
    throw error;
  }
};

export const getAllUsersForImpersonation = async (): Promise<ImpersonationUserDto[]> => {
  return http.get<ImpersonationUserDto[]>('/getAllUsers', z.array(ImpersonationUserDtoSchema));
};
